import useTripRequestId from 'businessTraveller/hooks/useTripRequestId'
import { withTripRequestIdCachePrefix } from 'businessTraveller/utils/generateItemPolicyKeys'
import { useMemo } from 'react'

/** Prefixes an item-policy cache key with the active trip request id when present. */
function useItemPolicyCacheKey(baseCacheKey: string): string {
  const tripRequestId = useTripRequestId()
  return useMemo(() => withTripRequestIdCachePrefix(baseCacheKey, tripRequestId), [baseCacheKey, tripRequestId])
}

export default useItemPolicyCacheKey
